import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tc-sidebar-user',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'user', '[class.clickable]': 'clickable()' },
  templateUrl: './sidebar-user.component.html',
  styleUrl: './sidebar-user.component.css',
})
export class SidebarUserComponent {
  initials = input<string>('');
  name = input<string>('');
  role = input<string>('');
  clickable = input<boolean>(false);
}
